import React from "react";
import { Flex, Image } from "@chakra-ui/react";
import { Link } from "react-router-dom";

function LogoArea() {
  return (
    <Link to="/dashboard" style={{ textDecoration: "none" }}>
      <Flex align="center" fontSize="2xl" fontWeight="bold">
        <Image
          src="../../logoWithTextNoBg.png"
          height={{ base: "40px", md: "45px" }}
          width="auto"
          maxW={{ base: "100%", sm: "140px", md: "180px" }}
          objectFit="contain"
          alt="Logo"
          // boxSize="36px"
          mr={2}
        />
      </Flex>
    </Link>
  );
}

export default LogoArea;
